'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonStyled = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var propTypes = {
  /** Define button's main text */
  text: _propTypes2.default.string,

  /** Define button's subtitle */
  subtitle: _propTypes2.default.string,

  /** Define button's size */
  size: _propTypes2.default.oneOf(['inline', 'small', 'normal', 'large']),

  /** Narrow button has smaller horizontal paddings */
  narrow: _propTypes2.default.bool,

  /** Define button's color */
  colorScheme: _propTypes2.default.oneOf(['primary', 'secondary', 'alert', 'success', 'warning', 'info', 'flat', 'flatLight', 'white', 'link']),

  /** Outlined button has border and transparent background */
  outlined: _propTypes2.default.bool,

  /** Define button's radius */
  radius: _propTypes2.default.oneOf(['none', 'default', 'rounded']),

  /** Raised button has shadow */
  raised: _propTypes2.default.bool,

  /** Set disable to true if interaction with button isn't available to user */
  disabled: _propTypes2.default.bool,

  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  // eslint-disable-next-line react/require-default-props
  theme: _propTypes2.default.object
};
var defaultProps = {
  text: '',
  subtitle: '',
  size: 'normal',
  narrow: false,
  colorScheme: 'flat',
  outlined: false,
  radius: 'default',
  raised: false,
  disabled: false
}; // PROP RECEIVERS

var sizeProps = function sizeProps(_ref) {
  var size = _ref.size,
      narrow = _ref.narrow,
      text = _ref.text,
      radius = _ref.radius,
      themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var paddingY = theme.reactackle.components.button.size[size].paddingY;
  var paddingX = theme.reactackle.components.button.size[size].paddingX;
  var narrowPaddingX = theme.reactackle.components.button.size[size].narrowPaddingX;
  var roundedPaddingX = theme.reactackle.components.button.size[size].roundedPaddingX;
  var py = text ? (0, _reactackleCore.getValueString)(paddingY) : 0;
  var px = null;
  if (narrow) px = (0, _reactackleCore.getValueString)(narrowPaddingX);else if (!text) px = '0 !important';else if (radius === 'rounded') px = (0, _reactackleCore.getValueString)(roundedPaddingX);else px = (0, _reactackleCore.getValueString)(paddingX);
  return 'padding: ' + py + ' ' + px + ';';
};

var radiusProps = function radiusProps(_ref2) {
  var radius = _ref2.radius,
      size = _ref2.size,
      themeFromProvider = _ref2.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var minHeight = theme.reactackle.components.button.size[size].minHeight;
  var borderRadiusDefault = theme.reactackle.components.button.borderRadiusDefault;
  var rad = null;
  if (radius === 'rounded') rad = 'border-radius: ' + (0, _reactackleCore.getValueString)(minHeight) + ';';else if (radius === 'default') rad = 'border-radius: ' + (0, _reactackleCore.getValueString)(borderRadiusDefault) + ';';else rad = 'border-radius: 0;';
  return rad;
};

var kindProps = function kindProps(_ref3) {
  var colorScheme = _ref3.colorScheme,
      outlined = _ref3.outlined,
      themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var backgroundColor = theme.reactackle.components.button.colorScheme[colorScheme].backgroundColor;
  var bgTransparency = (0, _color2.default)(backgroundColor).alpha() === 1;
  var hoverBackgroundColor = theme.reactackle.components.button.colorScheme[colorScheme].hover.backgroundColor;
  var focusBackgroundColor = theme.reactackle.components.button.colorScheme[colorScheme].focus.backgroundColor;
  var colorDark = theme.reactackle.components.button.text.colorDark;
  var colorLight = theme.reactackle.components.button.text.colorLight;
  var fontColor = theme.reactackle.components.button.colorScheme[colorScheme].fontColor || (0, _reactackleCore.foreground)(backgroundColor, colorDark, colorLight);
  var hoverFontColor = theme.reactackle.components.button.colorScheme[colorScheme].hover.fontColor;
  var focusFontColor = theme.reactackle.components.button.colorScheme[colorScheme].focus.fontColor;
  var borderWidth = theme.reactackle.components.button.borderWidth;
  var borderStyle = theme.reactackle.components.button.borderStyle;
  return (0, _styledComponents.css)(['', ''], outlined ? '\n        border-width: ' + (0, _reactackleCore.getValueString)(borderWidth) + ';\n        border-style: ' + borderStyle + ';\n        border-color: ' + (bgTransparency ? backgroundColor : fontColor) + ';\n        background-color: ' + (0, _color2.default)(backgroundColor).fade(1) + ';\n        color: ' + (bgTransparency ? backgroundColor : fontColor) + ';\n        \n        &:hover,\n        &:focus,\n        &:active {      \n          border-color: ' + (bgTransparency ? hoverBackgroundColor : hoverFontColor) + ';\n          background-color: ' + (bgTransparency ? (0, _color2.default)(hoverBackgroundColor).fade(0.9) : (0, _color2.default)(hoverFontColor).fade(0.9)) + ';\n          color: ' + (bgTransparency ? hoverBackgroundColor : hoverFontColor) + ';\n        }\n      ' : '          \n        background-color: ' + backgroundColor + ';\n        color: ' + fontColor + ';\n        border-width: 0;\n  \n        &:hover {\n          background-color: ' + hoverBackgroundColor + ';\n          color: ' + hoverFontColor + ';\n        }\n        \n        &:focus,\n        &:active {      \n          background-color: ' + focusBackgroundColor + ';\n          color: ' + focusFontColor + ';\n        }\n      ');
};

var elevation = function elevation(_ref4) {
  var raised = _ref4.raised;
  return '\n  ' + (raised ? (0, _reactackleCore.boxShadow)(0) + '\n              \n        &:hover,\n        &:focus,\n        &:active { \n          ' + (0, _reactackleCore.boxShadow)(2) + '    \n        }\n      ' : '\n      &:hover,\n      &:focus,\n      &:active { \n        box-shadow: none  \n      }\n    ') + '\n';
};

var disabled = function disabled(_ref5) {
  var disabled = _ref5.disabled,
      themeFromProvider = _ref5.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var backgroundColor = theme.reactackle.components.button.disabled.backgroundColor;
  var fontColor = theme.reactackle.components.button.disabled.fontColor; // remove pointerEvents when https://github.com/facebook/react/issues/4251 is resolved

  return (0, _styledComponents.css)(['', ''], disabled ? '\n          box-shadow: none;\n          pointer-events: none;\n          &,\n          &:hover,\n          &:focus,\n          &:active {\n            cursor: default;\n            background-color: ' + backgroundColor + ';\n            border-color: ' + backgroundColor + ';\n            color: ' + fontColor + ';\n            box-shadow: none;\n          };\n        ' : null);
};

var textProps = function textProps(_ref6) {
  var subtitle = _ref6.subtitle,
      size = _ref6.size,
      themeFromProvider = _ref6.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var fontSize = theme.reactackle.components.button.size[size].fontSize;
  var lineHeight = theme.reactackle.components.button.size[size].lineHeight;
  var textTransform = theme.reactackle.components.button.text.textTransform;
  var fontWeight = theme.reactackle.components.button.text.fontWeight;
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  return '   \n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    text-align: ' + (subtitle ? 'left' : 'center') + ';\n    text-decoration: none;\n    text-transform: ' + textTransform + ';\n    font-weight: ' + fontWeight + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
}; // STYLES


var Button = _styledComponents2.default.button.withConfig({
  displayName: 'ButtonStyled__Button'
})(['-webkit-appearance:none;-moz-appearance:none;cursor:pointer;margin:0;position:relative;display:inline-flex;user-select:none;vertical-align:middle;align-items:center;justify-content:center;box-sizing:border-box;text-decoration:none;&:hover,&:focus,&:active{outline:none;}', ';', ';', ';', ';', ';', ';', ';'], kindProps, textProps, sizeProps, radiusProps, elevation, disabled, (0, _reactackleCore.transition)('color, background-color, border, box-shadow'));

var Anchor = Button.withComponent('a'); // eslint-disable-next-line react/prop-types

var ButtonStyled = function ButtonStyled(_ref7) {
  var href = _ref7.href,
      props = _objectWithoutProperties(_ref7, ['href']);

  return href && href.length ? _react2.default.createElement(Anchor, _extends({
    href: href
  }, props)) : _react2.default.createElement(Button, props);
};

exports.ButtonStyled = ButtonStyled;
ButtonStyled.propTypes = propTypes;
ButtonStyled.defaultProps = defaultProps;
ButtonStyled.displayName = 'ButtonStyled';